var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contactum-fields" }, [
    _c("div", { staticClass: "ctm-color-preview-wrap" }, [
      _c("input", {
        staticClass: "ctm-color-input",
        attrs: { type: "color", disabled: "" },
        domProps: { value: _vm.field.default || "#000000" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "ctm-color-value" }, [
        _vm._v(_vm._s(_vm.field.default || "#000000"))
      ])
    ]),
    _vm._v(" "),
    _vm.field.help
      ? _c("span", { domProps: { innerHTML: _vm._s(_vm.field.help) } })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }